module.exports = __webpack_public_path__ + "img/e733552.png";